// Entity names for display: tab and grid titles come from the entity table (entity_registry.display_name_plural),
// so a view never hand-types what a thing is called. A block's own label or title is only the fallback for
// entities the registry does not know, and views still add their context ("... for Receipt X") through the title.
import { useEffect, useState } from 'react';

let names = new Map();   // entityName -> plural display name
let loading = null;
let version = 0;
const listeners = new Set();

const load = () => {
  if (names.size || loading) return loading;
  const token = localStorage.getItem('waide_access_token');
  loading = fetch('/api/v1/catalog/entities', { headers: { Authorization: `Bearer ${token}` } })
    .then((res) => (res.ok ? res.json() : null))
    .then((data) => {
      const next = new Map();
      (data?.entities || []).forEach((e) => {
        const name = e.displayNamePlural || e.displayName;
        if (e.entityName && name) next.set(e.entityName, name);
      });
      if (next.size) {
        names = next;
        version += 1;
        listeners.forEach((fn) => fn(version));
      }
    })
    .catch((err) => console.error('Failed to load entity names:', err))
    .finally(() => { loading = null; });
  return loading;
};

/** Plural display name for an entity, or null when the registry does not know it (yet). */
export const entityDisplayName = (entityName) => (entityName ? names.get(entityName) || null : null);

/** Loads the names on first use and re-renders the caller when they arrive. */
export const useEntityNames = () => {
  const [, setV] = useState(version);
  useEffect(() => {
    listeners.add(setV);
    load();
    return () => { listeners.delete(setV); };
  }, []);
  return version;
};
